import React from "react";
import YouTube from "react-youtube";

const YouTubeShort = ({ videoId }: any) => {
  const opts = {
    height: "250",
    width: "140", // 9:16 ratio
    playerVars: {
      modestbranding: 1,
      rel: 0,
    },
  };

  return <YouTube videoId={videoId} opts={opts} />;
};

export default YouTubeShort;
